import gs1Instance from '../api-index'

const { post, get, patch } = gs1Instance

const getSSCCLabelTable = async params => {
  const response = await get(`/gs1/standard/label/sscc/table`, params)
  return response.data
}

const getSSCCLabelDownload = async ({ clientId, traceId }) => {
  const response = await get(
    `/gs1/standard/label/sscc/${clientId}/${traceId}`,
    { responseType: 'blob' }
  )
  return response.data
}

const getSgtinTable = async () => {
  const response = await get('/gs1/standard/label/sgtin/table')
  return response.data
}

const getSsccTable = async () => {
  const response = await get('/gs1/standard/label/sscc/table')
  return response.data
}

const traceByBarcode = async (clientId, barcode) => {
  const response = await get(`/gs1/standard/label/${clientId}/${barcode}`)
  return response.data
}

const downloadSsccLabels = async (clientId, traceId) => {
  const response = await get(`/gs1/standard/label/sscc/${clientId}/${traceId}`)
  return response.data
}

const downloadSgtinLabels = async (clientId, traceId) => {
  const response = await get(`/gs1/standard/label/sgtin/${clientId}/${traceId}`)
  return response.data
}

const getPackingDetails = async (clientId, barcode) => {
  const response = await get(
    `/gs1/standard/label/content/${clientId}/${barcode}`
  )
  return response.data
}

const checkLabelEligibility = async (clientId, elementString, event) => {
  const response = await post(
    `/gs1/standard/label/check/${clientId}/${elementString}/${event}`
  )
  return response.data
}

export {
  getSgtinTable,
  getSsccTable,
  traceByBarcode,
  downloadSsccLabels,
  downloadSgtinLabels,
  getPackingDetails,
  checkLabelEligibility,
  getSSCCLabelTable,
  getSSCCLabelDownload
}
